import { CSSProperties } from 'react';
import { COLORS, FONTS, META, GLASS } from '../../globalStyles';

const rowBase: CSSProperties = {
  ...GLASS,
  borderTop: `1px solid ${COLORS.border}`,
  padding: '1.85rem 1.5rem',
};
const badgeAccent: CSSProperties = {
  color: COLORS.accent,
  border: `1px solid ${COLORS.borderAccent}`,
};

export const styles: Record<string, CSSProperties> = {
  row: rowBase,
  rowLast: { ...rowBase, borderBottom: `1px solid ${COLORS.border}` },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
  },
  index: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.accent,
    paddingTop: '0.1rem',
    flexShrink: 0,
  },
  info: {
    flex: 1,
  },
  title: {
    fontFamily: FONTS.body,
    fontSize: '1.15rem',
    fontWeight: 600,
    color: COLORS.text,
    marginBottom: '0.3rem',
  },
  description: {
    fontSize: '0.875rem',
    color: COLORS.muted,
    lineHeight: 1.6,
  },
  badge: {
    ...META,
    fontSize: '0.66rem',
    padding: '0.4rem 0.8rem',
    borderRadius: 0,
    whiteSpace: 'nowrap' as const,
    cursor: 'pointer',
    background: 'transparent',
  },
  badgeComingSoon: { ...badgeAccent, cursor: 'default' },
  badgeMore: badgeAccent,
  badgeLess: {
    color: COLORS.muted,
    border: `1px solid ${COLORS.border}`,
  },
  children: {
    overflow: 'hidden',
    transition: 'max-height 0.35s ease, opacity 0.35s ease',
  },
  childrenInner: {
    paddingTop: '1.25rem',
    paddingLeft: '3.5rem',
  },
};
